import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { FiUser, FiMail, FiMessageCircle } from '../assets/icons/vander';
import { getProductsdetail } from '../ApiService/productdetail/productdetail';

export default function ProductAboutTab({ selectedColor, products }) {
    const { product_id } = useParams();
    const [activeTab, setActiveTab] = useState(1);
    const [localProduct, setProduct] = useState(null);
    const [reviews, setReviews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Use passed product prop or fetch if not provided
    useEffect(() => {
        const fetchProduct = async () => {
            setLoading(true);
            setError(null);
            try {
                let productData = products;
                console.log(`Product prop received: ${JSON.stringify(products)} (03:08 PM IST, Oct 6, 2025)`);
                if (!products && product_id) {
                    console.log(`Fetching product for product_id: ${product_id} (03:08 PM IST, Oct 6, 2025)`);
                    const response = await getProductsdetail(product_id);
                    console.log(`Fetched product details: ${JSON.stringify(response)} (03:08 PM IST, Oct 6, 2025)`);
                    productData = response.results && response.results.length > 0 ? response.results[0] : null;
                }
                if (productData) {
                    setProduct(productData);
                    console.log(`Set localProduct: ${JSON.stringify(productData)} (03:08 PM IST, Oct 6, 2025)`);
                } else {
                    setError("No product data available");
                    console.log(`No product data found for product_id: ${product_id} (03:08 PM IST, Oct 6, 2025)`);
                }
            } catch (error) {
                setError("Failed to fetch product details");
                console.error(`Error fetching product detail for product_id: ${product_id}: ${error.message} (03:08 PM IST, Oct 6, 2025)`);
            } finally {
                setLoading(false);
            }
        };
        fetchProduct();
    }, [product_id, products]);

    // Mock reviews data
    useEffect(() => {
        const mockReviews = [
            {
                name: "John Doe",
                time: "2025-10-01",
                desc: "Great shirt, very comfortable!",
                rating: 5,
                image: "https://via.placeholder.com/44"
            },
            {
                name: "Jane Smith",
                time: "2025-10-02",
                desc: "Good quality, but sizing runs small.",
                rating: 4,
                image: "https://via.placeholder.com/44"
            }
        ];
        setReviews(mockReviews);
        console.log(`Loaded mock reviews: ${JSON.stringify(mockReviews)} (03:08 PM IST, Oct 6, 2025)`);
    }, [product_id]);

    // Render stars
    const renderStars = (rating) => {
        const stars = [];
        for (let i = 1; i <= 5; i++) {
            stars.push(
                <li key={i} className="inline">
                    <i className={`mdi mdi-star text-lg ${i <= rating ? "text-orange-400" : "text-gray-300"}`}></i>
                </li>
            );
        }
        return stars;
    };

    // Get selected variant's fabric
    const getSelectedFabric = () => {
        console.log(`getSelectedFabric called with selectedColor: ${selectedColor}, localProduct: ${JSON.stringify(localProduct)} (03:08 PM IST, Oct 6, 2025)`);
        const variant = localProduct?.variants?.find(v => v.color === selectedColor) || localProduct?.variants?.[0];
        const fabric = variant?.fabric || "N/A";
        console.log(`getSelectedFabric: selectedColor: ${selectedColor}, fabric: ${fabric} (03:08 PM IST, Oct 6, 2025)`);
        return fabric;
    };

    if (loading) {
        return <div className="text-center p-6">Loading product details...</div>;
    }

    if (error) {
        return <div className="text-center p-6 text-red-500">{error}</div>;
    }

    return (
        <div className="grid md:grid-cols-12 grid-cols-1 mt-6 gap-6">
            <div className="lg:col-span-3 md:col-span-5">
                <div className="sticky top-20">
                    <ul className="flex-column p-6 bg-white dark:bg-slate-900 shadow dark:shadow-gray-800 rounded-md" id="myTab" data-tabs-toggle="#myTabContent" role="tablist">
                        <li className="ms-0">
                            <button
                                className={`px-4 py-2 text-start text-base font-semibold rounded-md w-full hover:text-green-500 duration-500 ${activeTab === 1 ? 'text-white bg-green-500 hover:text-white' : ''}`}
                                onClick={() => setActiveTab(1)}
                            >
                                Description
                            </button>
                        </li>
                        <li className="ms-0">
                            <button
                                className={`px-4 py-2 text-start text-base font-semibold rounded-md w-full hover:text-green-500 duration-500 ${activeTab === 2 ? 'text-white bg-green-500 hover:text-white' : ''}`}
                                onClick={() => setActiveTab(2)}
                            >
                                Additional Information
                            </button>
                        </li>
                        <li className="ms-0">
                            <button
                                className={`px-4 py-2 text-start text-base font-semibold rounded-md w-full hover:text-green-500 duration-500 ${activeTab === 3 ? 'text-white bg-green-500 hover:text-white' : ''}`}
                                onClick={() => setActiveTab(3)}
                            >
                                Review
                            </button>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="lg:col-span-9 md:col-span-7">
                <div id="myTabContent" className="p-6 bg-white dark:bg-slate-900 shadow dark:shadow-gray-800 rounded-md">
                    {activeTab === 1 && (
                        <div>
                            <p className="text-slate-400">
                                {localProduct?.description || "No description available"}
                            </p>
                        </div>
                    )}
                    {activeTab === 2 && (
                        <div>
                            <table className="w-full text-start">
                                <tbody>
                                    <tr className="bg-white dark:bg-slate-900">
                                        <td className="font-semibold pb-4" style={{ width: '100px' }}>Color</td>
                                        <td className="text-slate-400 pb-4">
                                            {selectedColor || "N/A"}
                                        </td>
                                    </tr>
                                    <tr className="bg-white dark:bg-slate-900 border-t border-gray-100 dark:border-gray-700">
                                        <td className="font-semibold py-4">Material</td>
                                        <td className="text-slate-400 py-4">
                                            {getSelectedFabric()}
                                        </td>
                                    </tr>
                                    <tr className="bg-white dark:bg-slate-900 border-t border-gray-100 dark:border-gray-700">
                                        <td className="font-semibold py-4">Size</td>
                                        <td className="text-slate-400 py-4">
                                            {localProduct?.attributes?.size?.join(", ") || "N/A"}
                                        </td>
                                    </tr>
                                    <tr className="bg-white dark:bg-slate-900 border-t border-gray-100 dark:border-gray-700">
                                        <td className="font-semibold py-4">Gender</td>
                                        <td className="text-slate-400 py-4">
                                            {localProduct?.attributes?.gender?.join(", ") || "N/A"}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}
                    {activeTab === 3 && (
                        <div>
                            {reviews.length > 0 ? (
                                reviews.map((item, index) => (
                                    <div className="mt-8 first:mt-0" key={index}>
                                        <div className="flex items-center justify-between">
                                            <div className="flex items-center">
                                                <img src={item.image} className="h-11 w-11 rounded-full shadow" alt={item.name} />
                                                <div className="ms-3 flex-1">
                                                    <Link to="" className="text-lg font-semibold hover:text-green-500 duration-500">{item.name}</Link>
                                                    <p className="text-sm text-slate-400">{item.time}</p>
                                                </div>
                                            </div>
                                            <Link to="" className="text-slate-400 hover:text-green-500 duration-500 ms-5">
                                                <i className="mdi mdi-reply"></i> Reply
                                            </Link>
                                        </div>
                                        <div className="p-4 bg-gray-50 dark:bg-slate-800 rounded-md shadow dark:shadow-gray-800 mt-6">
                                            <ul className="list-none inline-block text-orange-400">
                                                {renderStars(item.rating)}
                                                <li className="inline text-slate-400 font-semibold">{item.rating}.0</li>
                                            </ul>
                                            <p className="text-slate-400 italic">{item.desc}</p>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p className="text-slate-400">No reviews available</p>
                            )}
                            <div className="p-6 rounded-md shadow dark:shadow-gray-800 mt-8">
                                <h5 className="text-lg font-semibold">Leave A Comment:</h5>
                                <form className="mt-8" onSubmit={(e) => {
                                    e.preventDefault();

                                     const newReview = {
            name: e.target.name.value,
            email: e.target.email.value, // optional, can be used later
            desc: e.target.comments.value,
            rating: 5, // Default rating, you can add a rating input later
            time: new Date().toISOString().split("T")[0], // Current date
            image: "https://via.placeholder.com/44" // default avatar
        };
                                    // console.log(`Form submitted: ${JSON.stringify({
                                    //     name: e.target.name.value,
                                    //     email: e.target.email.value,
                                    //     comments: e.target.comments.value
                                    // })} (03:08 PM IST, Oct 6, 2025)`);
                                      setReviews((prev) => [newReview, ...prev]);
                                    e.target.reset();
                                  
   setActiveTab(3);
                                }}>
                                    <div className="grid lg:grid-cols-12 lg:gap-6">
                                        <div className="lg:col-span-6 mb-5">
                                            <div className="text-start">
                                                <label htmlFor="name" className="font-semibold">Your Name:</label>
                                                <div className="form-icon relative mt-2">
                                                    <FiUser className="w-4 h-4 absolute top-3 start-4"></FiUser>
                                                    <input name="name" id="name" type="text" className="ps-11 w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0" placeholder="Name :" required />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="lg:col-span-6 mb-5">
                                            <div className="text-start">
                                                <label htmlFor="email" className="font-semibold">Your Email:</label>
                                                <div className="form-icon relative mt-2">
                                                    <FiMail className="w-4 h-4 absolute top-3 start-4"></FiMail>
                                                    <input name="email" id="email" type="email" className="ps-11 w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0" placeholder="Email :" required />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="grid grid-cols-1">
                                        <div className="mb-5">
                                            <div className="text-start">
                                                <label htmlFor="comments" className="font-semibold">Your Comment:</label>
                                                <div className="form-icon relative mt-2">
                                                    <FiMessageCircle className="w-4 h-4 absolute top-3 start-4"></FiMessageCircle>
                                                    <textarea name="comments" id="comments" className="ps-11 w-full py-2 px-3 h-28 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0" placeholder="Message :" required></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <button type="submit" id="submit" name="send" className="py-2 px-5 inline-block font-semibold tracking-wide align-middle duration-500 text-base text-center bg-green-500 text-white rounded-md w-full">Send Message</button>
                                </form>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}